import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Rangepicker from "./Rangepicker";
import RedpinIcon from "../../../assets/location_icon_12.PNG";
import Inputbox from "../../../components/formcontrols/normal/InputBox";
import Tint from "../../../utility/ImageTint/Tint";
import deleteimg from "../../../assets/delete-transformed.png";

function fetchWithTimeout(resource, options = {}, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error("timeout")), timeout);

    fetch(resource, options)
      .then((res) => {
        clearTimeout(timer);
        resolve(res);
      })
      .catch((err) => {
        clearTimeout(timer);
        reject(err);
      });
  });
}

const getLocationName = async (coordString) => {
  const [lat, lon] = coordString.split(",").map((x) => x.trim());

  if (isNaN(lat) || isNaN(lon)) throw new Error("Invalid coords");

  const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`;

  const res = await fetchWithTimeout(url);
  const data = await res.json();

  if (!data?.display_name) throw new Error("No data");

  return data.display_name;
};

const LocationRangePickerModal = ({
  isOpen,
  onClose,
  selectedLocation = {},
  onDeleteLocation,
  onEditLocation,
  orggpscoordinates = [],
  setOrggpscoordinates,
  grouplist = [],
}) => {
  console.log(selectedLocation,"selectedLocation")
  const [locationName, setLocationName] = useState({
    status: "loading",
    value: "",
  });

  const [locationNameColor, setLocationNameColor] = useState("black");
  const [locationnameget, setLocationNameGet] = useState("");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(true);
  const [currentRange, setCurrentRange] = useState(25);

  const getNextLocationId = () => {
    if (!orggpscoordinates.length) return "1";

    const maxId = Math.max(
      ...orggpscoordinates.map((l) => Number(l.locationid) || 0)
    );

    return String(maxId + 1);
  };

  useEffect(() => {
    if (!isOpen) return;

    setLocationNameGet(selectedLocation?.locationname || "");
    setLocationNameColor("black");
  }, [isOpen, selectedLocation?.locationid]);

  useEffect(() => {
    if (!isOpen) return;

    const groupids = selectedLocation?.groupids ?? "-1";

    if (groupids === -1 || groupids === "-1") {
      setIsAllSelected(true);
      setSelectedGroups([-1]);
    } else {
      setIsAllSelected(false);

      const parsed = String(groupids)
        .split(",")
        .map((id) => Number(id.trim()))
        .filter((id) => !Number.isNaN(id));

      setSelectedGroups(parsed);
    }
  }, [isOpen, selectedLocation?.locationid]);

  useEffect(() => {
    if (!isOpen) return;

    setCurrentRange(Number(selectedLocation?.range || 25));
  }, [isOpen, selectedLocation?.locationid]);

  useEffect(() => {
    if (!isOpen || !selectedLocation?.lat || !selectedLocation?.lng) return;

    let ignore = false;

    const fetchLocation = async () => {
      setLocationName({ status: "loading", value: "" });

      try {
        const name = await getLocationName(
          `${selectedLocation.lat},${selectedLocation.lng}`
        );

        if (!ignore) {
          setLocationName({
            status: "success",
            value: name,
          });
        }
      } catch (err) {
        if (!ignore) {
          setLocationName({
            status: "error",
            value: "Unable to fetch location",
          });
        }
      }
    };

    fetchLocation();

    return () => {
      ignore = true;
    };
  }, [
    isOpen,
    selectedLocation?.locationid,
    selectedLocation?.lat,
    selectedLocation?.lng,
  ]);

  const saveAndClose = () => {
    if (!locationnameget?.trim()) {
      setLocationNameColor("red");
      return;
    }

    const isNew =
      selectedLocation?.locationid === undefined ||
      selectedLocation?.locationid === null ||
      selectedLocation?.locationid === "";

    const updatedData = {
      ...selectedLocation,
      locationname: locationnameget.trim(),
      range: currentRange || 25,
      groupids: isAllSelected ? "-1" : selectedGroups.join(","),
    };

    let updatedCoords;

    if (isNew) {
      updatedCoords = [
        ...orggpscoordinates,
        {
          ...updatedData,
          locationid: getNextLocationId(),
        },
      ];
    } else {
      updatedCoords = orggpscoordinates.map((loc) =>
        String(loc.locationid) === String(selectedLocation.locationid)
          ? {
              ...loc,
              ...updatedData,
              locationid: loc.locationid,
            }
          : loc
      );
    }

    setOrggpscoordinates(updatedCoords);
    onClose();
  };

  const handleRangeChange = (range) => {
    setCurrentRange(range);
  };

  const handleCheckboxChange = (e, applgroupid) => {
    let updated = [...selectedGroups];

    if (applgroupid === -1) {
      setIsAllSelected(e.target.checked);
      updated = e.target.checked ? [-1] : [];
    } else {
      if (e.target.checked) {
        setIsAllSelected(false);
        updated.push(applgroupid);
      } else {
        updated = updated.filter((id) => id !== applgroupid);
      }

      if (updated.includes(-1)) {
        updated = updated.filter((id) => id !== -1);
      }
    }

    setSelectedGroups(updated);
  };

  const getDisplayText = () => {
    if (locationName.status === "loading") return "Fetching location...";
    if (locationName.status === "error") return locationName.value;
    return locationName.value;
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      <Modal.Body style={{ padding: 0, borderRadius: 18, overflow: "hidden" }}>
        <div style={{ padding: 18, background: "#fafafa" }}>
          <div className="row d-flex align-items-start">
            <div className="col-10">
              <Inputbox
                wordboundation={{ limit: 50, id: "locationname" }}
                htmlFor="locationname"
                label="LOCATION NAME"
                type="text"
                labelStyle={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: locationNameColor,
                }}
                placeholder="Enter location name"
                value={locationnameget}
                inputStyle={{ paddingLeft: "0px", fontSize: "14px" }}
                onChange={(e) => {
                  setLocationNameGet(e.target.value);
                  setLocationNameColor("black");
                }}
                required={true}
              />
            </div>

            <div
              className="col-2 d-flex align-items-start"
              style={{
                padding: "14px 16px",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "start",
                fontWeight: 600,
              }}
            >
              <IconButton size="small" onClick={onDeleteLocation}>
                <img
                  src={deleteimg}
                  alt="delete"
                  style={{ width: "20px", filter: Tint("#ff0000") }}
                />
              </IconButton>
            </div>
          </div>

          <div
            onClick={onEditLocation}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              borderRadius: 14,
              background: "#fff",
              cursor: "pointer",
            }}
          >
            <img
              src={RedpinIcon}
              alt="location"
              style={{ width: 18, filter: Tint("#ff0000") }}
            />

            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 400 }}>
                {getDisplayText()}
              </div>
            </div>
          </div>

          <div style={{ marginTop: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>
              Range (meters)
            </div>

            <div style={{ padding: 12, paddingTop: "0px", borderRadius: 12 }}>
              <Rangepicker
                key={selectedLocation?.locationid || "new"}
                default={currentRange}
                value={currentRange}
                onChange={handleRangeChange}
              />
            </div>
          </div>

          <div style={{ marginTop: 6 }}>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>
              Groups
            </div>

            {grouplist.length > 0 ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "2px 6px",
                  borderRadius: 12,
                }}
              >
                {grouplist.map((res) => (
                  <FormControlLabel
                    key={res.applgroupid}
                    control={
                      <Checkbox
                        checked={
                          res.applgroupid === -1
                            ? isAllSelected
                            : selectedGroups.includes(res.applgroupid)
                        }
                        onChange={(e) =>
                          handleCheckboxChange(e, res.applgroupid)
                        }
                        sx={{
                          color: "#29b6f6",
                          "&.Mui-checked": { color: "#29b6f6" },
                        }}
                      />
                    }
                    label={res.applgroupname}
                    sx={{
                      margin: 0,
                      "& .MuiFormControlLabel-label": {
                        fontSize: 13,
                        color: "#444",
                      },
                    }}
                  />
                ))}
              </div>
            ) : (
              <div style={{ color: "#999", fontSize: 13 }}>No Group List</div>
            )}
          </div>
        </div>

        <div style={{ padding: 10, display: "flex", justifyContent: "center" }}>
          <button
            onClick={saveAndClose}
            style={{
              padding: "8px 18px",
              borderRadius: 8,
              border: "none",
              background: "#29b6f6",
              color: "#fff",
              fontWeight: 600,
            }}
          >
            OK
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LocationRangePickerModal;